<template>
  <div>
    <van-field readonly clickable right-icon="arrow-down" placeholder="请选择" :value="valueYMD" @click="popup = true" />
    <van-popup ref="popup" v-model="popup" round position="bottom" :close-on-click-overlay="false">
      <van-picker
        title="请选择年"
        show-toolbar
        :columns="columns"
        :default-index="defaultIndex"
        @cancel="popup = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import DateTimeHour from './DateTimeHour'

export default {
  name: 'DateTimeYear',
  extends: DateTimeHour,
  props: {},
  data() {
    return {
      popupMS: false,
      valueHMS: '',
      valueYMD: '',
      columns: [],
      defaultIndex: 0
    }
  },
  created() {
    if (this.value.length) {
      this.valueYMD = this.value
    } else {
      let uw = this.$watch('value', val => {
        this.valueYMD = val
        uw()
      })
    }
    this.initColumns()
  },
  methods: {
    initColumns() {
      const maxYear = this.maxDate.getFullYear()
      let star = this.minDate.getFullYear()
      let res = []
      while (star <= maxYear) {
        res.push(star.toString())
        star++
      }
      const currentYear = new Date().getFullYear().toString()
      const index = res.findIndex(r => r === currentYear)
      if (index > -1) {
        this.defaultIndex = index
      }
      this.columns = res
    },
    onConfirm(value) {
      this.valueYMD = value
      this.popup = false
      this.$emit('input', value)
    }
  }
}
</script>
